import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../store/actions/index';
import {useHistory} from "react-router-dom";
import LockIcon from '@material-ui/icons/Lock';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailIcon from '@material-ui/icons/Email';
import {getFormData, inputChangedHandler, prepareFormData, updateObject, validateForm} from "../../shared/utility";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import {makeStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import TextField from "@material-ui/core/TextField";
import {Box, IconButton} from "@material-ui/core";
import {Person, Room, Visibility, VisibilityOff} from "@material-ui/icons";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import TermsModal from "../../components/modals/TermsModal";
import {ZipFormatter} from '../../shared/formatter';
//import Auth0Config from "../../config/auth0";


const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: "10px",
        marginBottom: "10px",
        position: 'relative',
    },
    checkbox: {
        color: '#00AEEF',
    }
}));


let formData = {
    controls: {
        firstName: {
            label: 'First Name',
            value: '',
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,

        },
        lastName: {
            label: 'Last Name',
            value: '',
            validation: {
                presence: {allowEmpty: false}
            },
            valid: false,
            touched: false,
        },
        zip: {
            label: 'ZIP Code',
            value: '',
            validation: {length: { minimum: 1, maximum: 5, allowEmpty: false, message: 'can\'t be blank'}},
            inputFilter: '[^0-9]',
            valid: false,
            touched: false,
        },
        email: {
            label: 'Email Address',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                email: { message: 'is not a valid' }
            },
            valid: false,
            touched: false,
        },
        password: {
            label: 'Password',
            value: '',
            validation: {
                presence: {allowEmpty: false}, 
                length: {minimum: 8, allowEmpty: false},
            },
            valid: false,
            touched: false,
            showPassword: false,

        },
        terms: {
            validation: {
                presence: {allowEmpty: false}
            },
            valid: true,
            label: 'I opt-in to Carwiser terms and conditions.',
            valid: true,
            touched: false,

        }

    },

    loading: false,
    valid: false,
    touched: false,
    generalError: null

}


const Register = (props) => {

    const classes = useStyles();
    const [termsModal, setTermsModal] = React.useState(false);
    const [isRegistered, setIsRegistered] = React.useState(false);
    formData = prepareFormData(formData);
    const [formState, setFormState] = useState(formData);
    const history = useHistory();

    useEffect(() => {
        if (props.isAuthenticated) {
            history.push('/dashboard')
        }
    });


    const firstNameField = formState.controls.firstName;
    const lastNameField = formState.controls.lastName;
    const zipField = formState.controls.zip;
    const emailField = formState.controls.email;
    const passwordField = formState.controls.password;
    const termsField = formState.controls.terms;


    // firstNameField.value = Auth0Config.testUser.firstName;
    // lastNameField.value = Auth0Config.testUser.lastName;
    // zipField.value = Auth0Config.testUser.zip;
    // emailField.value = Auth0Config.testUser.email;
    // passwordField.value = Auth0Config.testUser.password;

    const submitHandler = async (event) => {
        event.preventDefault();
        if (validateForm(formState, setFormState)) {
            zipField.value = ZipFormatter.format(zipField.value);
            setFormState(formState);
            const data = getFormData(formState)
            props.onRegister(data, () => {
                setIsRegistered(true)
            });
        }

    }
    const passShowedHandler = () => {
        const updatedState = updateObject(formState.controls);
        updatedState.password.showPassword = !updatedState.password.showPassword
        setFormState(updateObject(formState, {controls: updatedState}));
    }

    const successMessage = (
        <React.Fragment>
            <Alert severity="" style={{fontSize: '20px', background: "transparent"}}><p><strong>Verify your
                account</strong></p><p>Thanks for signing up. Confirm your email address to activate your account.</p>
            </Alert>
            <Button type={"submit"} fullWidth variant={"contained"} color={"primary"} size={"large"} 
                className="LoginButton" onClick={(e) => {
                e.preventDefault();
                history.push('/')
            }}>Back to Log In</Button>
        </React.Fragment>
    )

    return (
        <React.Fragment>
            <Box align={'center'} style={{marginBottom: '25px'}}>
                <Box style={{fontSize: '20px', maxWidth: '483px'}} display={{xs: 'none', sm: 'none', md: 'block'}}>
                    {!isRegistered &&
                    <span>Create an account below to save your car information while we find the best possible buyer for you in our national network.</span>}
                    {isRegistered && successMessage}
                </Box>
                <Box style={{fontSize: '16px', maxWidth: '350px', color: "white"}}
                     display={{xs: 'block', sm: 'block', md: 'none'}}>
                    {!isRegistered &&
                    <span>Create an account to save your car info while we find the best possible buyer for you.</span>}
                    {isRegistered && successMessage}
                </Box>

            </Box>
            {!isRegistered &&
            <Box align={'center'}>
                <Box justifyContent={'flex-start'} style={{width: '350px'}}>
                    <form className={classes.form} noValidate onSubmit={submitHandler}>
                        <div>
                            <TextField
                                name={firstNameField.key}
                                value={firstNameField.value}
                                type={'input'}
                                fullWidth
                                placeholder={firstNameField.label}
                                margin="normal"
                                variant="outlined"
                                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, firstNameField.key)}
                                helperText={firstNameField.helperText}
                                error={!firstNameField.valid && firstNameField.touched}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Person/>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div>
                            <TextField
                                name={lastNameField.key}
                                value={lastNameField.value}
                                type={'input'}
                                placeholder={lastNameField.label}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, lastNameField.key)}
                                helperText={lastNameField.helperText}
                                error={!lastNameField.valid && lastNameField.touched}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon/>
                                        </InputAdornment>
                                    ),
                                }}

                            />
                        </div>
                        <div>
                            <TextField
                                name={zipField.key}
                                value={zipField.value}
                                type={'input'}
                                inputProps={{ maxLength: zipField.validation.length.maximum }}
                                placeholder={zipField.label}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, zipField.key)}
                                helperText={zipField.helperText}
                                error={!zipField.valid && zipField.touched}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Room/>
                                        </InputAdornment>
                                    ),
                                }}

                            />
                        </div>
                        <div>
                            <TextField
                                name={emailField.key}
                                value={emailField.value}
                                type={'input'}
                                placeholder={emailField.label}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, emailField.key)}
                                helperText={emailField.helperText}
                                error={!emailField.valid && emailField.touched}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon/>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>
                        <div>
                            <TextField
                                name='password'
                                value={passwordField.value}
                                type={passwordField.showPassword ? 'input' : 'password'}
                                placeholder={passwordField.label}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                onChange={event => inputChangedHandler(formState, setFormState, event.target.value, passwordField.key)}
                                helperText={passwordField.helperText}
                                error={!passwordField.valid && passwordField.touched}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LockIcon/>
                                        </InputAdornment>
                                    ),
                                    endAdornment: (<InputAdornment position="end">
                                        <IconButton
                                            className="AdornmentIconButton"
                                            onClick={passShowedHandler}
                                            edge="end"

                                        >
                                            {passwordField.showPassword ? <Visibility color={'black'}/> :
                                                <VisibilityOff/>}
                                        </IconButton>
                                    </InputAdornment>)
                                }}
                            />

                        </div>

                        {props.error &&
                        <div>
                            <Alert severity="error">{props.error.message ?? ''}</Alert>
                        </div>
                        }

                        <div className={classes.wrapper}>
                            <Button type={"submit"} fullWidth variant={"contained"} color={"primary"} size={"large"}
                                    className="LoginButton"
                                    disabled={props.loading}>Create Account</Button>
                            {props.loading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                        </div>
{/* 
                        <div className={classes.wrapper}>
                            <Button className={classes.button} type={"button"} variant={"outlined"} onClick={() => {
                                history.push('/dashboard')
                            }}
                            > Cancel</Button>

                            <Button className={classes.button} type={"button"} variant={"contained"} color={"primary"}
                                  
                            > Save</Button>

<Button className={classes.button} type={"button"} variant={"contained"} color={"primary"}
                                  
                                  > Details</Button>
                        </div> */}

                        <div style={{textAlign: 'left'}}>
                            <FormControl required error={termsField.helperText ? true : false} component="fieldset"
                                         className={classes.formControl}>
                                <FormGroup>
                                    <FormControlLabel
                                        className={classes.checkbox}
                                        control={<Checkbox
                                            checked={termsField.value}
                                            onChange={() => inputChangedHandler(formState, setFormState, termsField.value ? '' : true, termsField.key)}
                                            color='default'
                                        />}
                                        label={<span onClick={(e) => {
                                            e.preventDefault()
                                            setTermsModal(true)
                                        }} style={{fontSize: "12px"}}>I opt-in to Carwiser <u>terms and conditions</u>.</span>}
                                        helperText={termsField.helperText}
                                        error={!termsField.valid && termsField.touched}
                                    />
                                </FormGroup>
                                <FormHelperText>{(termsField.helperText) ? 'You must accept the terms and conditions to continue' : ''}</FormHelperText>
                            </FormControl>
                        </div>
                    </form>

                </Box>
            </Box>
            }
            <TermsModal open={termsModal}
                        handleClose={() => {
                            setTermsModal(false)
                        }}/>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.isAuthenticated
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRegister: (data, onSuccess) => dispatch(actions.register(data, onSuccess)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
